import * as R from "ramda";

import { IAppState } from "../../reducers/index";

export default (state: IAppState, id: string) =>
  R.compose(
    R.find(R.propEq("id", parseInt(id, 10))),
    R.pathOr([], ["items", "items"])
  )(state);
